import { ACTION_TYPES } from '../utils/Constants';

let initalState = {
    isOnline: true,
    isNetworkProblem: false,
    isUserActive: false,
    isSocketDownProblem: false,
    deactivateUserScreen: false,
};

const NetworkReducer = (state = initalState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.NETWORK_CHNAGE:
            state = {
                ...state,
                isOnline: action.payload.isOnline,
                isNetworkProblem: false,
            };
            break;
        case ACTION_TYPES.NETWORK_PROBLEM:
            state = {
                ...state,
                isNetworkProblem: action.payload.isNetworkProblem,
            };
            break;
        case ACTION_TYPES.SOCKET_SERVER_DOWN_PROBLEM:
            state = {
                ...state,
                isSocketDownProblem: action.payload.isSocketDownProblem,
            };
            break;
        case ACTION_TYPES.INACTIVE_USER:
            state = {
                ...state,
                isUserActive: true,
            };
            break;
        case ACTION_TYPES.DEACTIVATE_USER_SCREEN:
            state = {
                ...state,
                deactivateUserScreen: action.payload.deactivateUser,
            };
            break;
        default:
            break;
    }
    return state;
};
export default NetworkReducer;
